/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Field, getIn } from 'formik';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

export const RenderTimeSelectField = ({
  field,
  form: { touched, errors, setFieldValue },
  onChangeChecker,
  fullWidth,
  ...others
}) => {
  const { classes } = useStyles();
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  return (
    <TimePicker
      ampm={false}
      name={field.name}
      value={field.value}
      onChange={(date, value) => {
        if (date?.isValid()) {
          setFieldValue(field.name, date);
        } else {
          setFieldValue(field.name, null);
        }
      }}
      minutesStep={5}
      invalidLabel="Desconhecido"
      invalidDateMessage="Formato inválido"
      cancelLabel="Cancelar"
      clearLabel="Limpar"
      slotProps={{
        textField: {
          fullWidth: fullWidth,
          error: touch && error != null,
          helperText: touch && error,
          variant: 'standard',
          className: classes.formControl,
          InputLabelProps: { shrink: true },
        },
      }}
      {...others}
    />
  );
};

export const FormTimeField = ({ name, ...others }) => {
  return <Field name={name} component={RenderTimeSelectField} {...others} />;
};
